/**
 * 西洋占星圓盤（極簡）。
 *
 * SVG 畫一個外圈 + 12 等分、標 12 星座符號。真實 house 分角、行星點位之後串 worker。
 */

const SIGNS = [
  '♈', // 白羊
  '♉', // 金牛
  '♊', // 雙子
  '♋', // 巨蟹
  '♌', // 獅子
  '♍', // 處女
  '♎', // 天秤
  '♏', // 天蠍
  '♐', // 射手
  '♑', // 魔羯
  '♒', // 水瓶
  '♓', // 雙魚
];

interface WesternMiniChartProps {
  sunSign?: string; // 太陽星座（高亮）
}

export function WesternMiniChart({ sunSign }: WesternMiniChartProps) {
  const size = 140;
  const radius = size / 2 - 6;
  const center = size / 2;

  return (
    <div className="rounded-lg border border-paper bg-cream/60 p-3">
      <h3 className="mb-2 text-xs font-medium text-ink/60">西洋</h3>
      <div className="flex justify-center">
        <svg
          viewBox={`0 0 ${size} ${size}`}
          width="100%"
          className="max-w-[140px]"
          aria-hidden
        >
          {/* 外圈 */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke="rgba(26,24,20,0.2)"
            strokeWidth={1}
          />
          {/* 12 分隔線 */}
          {SIGNS.map((_, i) => {
            const angle = (i * 30 - 90) * (Math.PI / 180);
            const x2 = center + Math.cos(angle) * radius;
            const y2 = center + Math.sin(angle) * radius;
            return (
              <line
                key={i}
                x1={center}
                y1={center}
                x2={x2}
                y2={y2}
                stroke="rgba(26,24,20,0.08)"
                strokeWidth={0.5}
              />
            );
          })}
          {/* 12 星座符號 */}
          {SIGNS.map((s, i) => {
            const angle = (i * 30 - 75) * (Math.PI / 180);
            const r = radius - 12;
            const x = center + Math.cos(angle) * r;
            const y = center + Math.sin(angle) * r;
            const isSun = s === sunSign;
            return (
              <text
                key={s}
                x={x}
                y={y}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize={isSun ? 14 : 10}
                fontWeight={isSun ? 700 : 400}
                fill={isSun ? '#8b5a2b' : 'rgba(26,24,20,0.7)'}
              >
                {s}
              </text>
            );
          })}
        </svg>
      </div>
    </div>
  );
}
